interface CopyIconProps {
  color?: string;
  width?: number;
  height?: number;
}

const CopyIcon = ({ color = "#34C759", width = 19, height = 22 }: CopyIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4791 19.325C13.6914 19.325 15.4916 17.5247 15.4916 15.3125V6.98163C15.4916 5.90985 15.0743 4.90227 14.3164 4.14435L11.9473 1.77519C11.1894 1.01728 10.1827 0.599976 9.10999 0.599976H4.34581C2.13359 0.599976 0.333313 2.40025 0.333313 4.61248V15.3125C0.333313 17.5247 2.13359 19.325 4.34581 19.325H11.4791ZM13.686 4.77476C14.0222 5.11092 14.2611 5.51395 14.4136 5.94998H11.0333C10.542 5.94998 10.1416 5.54962 10.1416 5.05831V1.678C10.5777 1.83048 10.9807 2.06944 11.3169 2.4056L13.686 4.77476ZM1.22498 15.3125V4.61248C1.22498 2.89156 2.6249 1.49164 4.34581 1.49164H9.10999C9.15725 1.49164 9.20272 1.50323 9.24998 1.50502V5.05831C9.24998 6.04182 10.0498 6.84164 11.0333 6.84164H14.5866C14.5884 6.8889 14.6 6.93438 14.6 6.98163V15.3125C14.6 17.0334 13.2001 18.4333 11.4791 18.4333H4.34581C2.6249 18.4333 1.22498 17.0334 1.22498 15.3125ZM18.1666 8.17914V17.9875C18.1666 20.1997 16.3664 22 14.1541 22H3.45415C3.20805 22 3.00831 21.8002 3.00831 21.5541C3.00831 21.308 3.20805 21.1083 3.45415 21.1083H14.1541C15.8751 21.1083 17.275 19.7084 17.275 17.9875V8.17914C17.275 7.93304 17.4747 7.73331 17.7208 7.73331C17.9669 7.73331 18.1666 7.93304 18.1666 8.17914Z"
        fill={color}
      />
    </svg>
  );
};

export default CopyIcon;
